import EventEmitter3 from 'eventemitter3'

export const EventEmitter = new EventEmitter3()
